const PROFILES_TYPE_HORSE_PROFILES = 'horses_profiles';

/**
 * Map of available profile types
 */
export const profilesTypes = {
    [PROFILES_TYPE_HORSE_PROFILES]: 'Horses',
    jockeys_profiles: 'Jockeys',
    trainers_profiles: 'Trainers',
    owners_profiles: 'Owners',
    courses: 'Courses',
};

/**
 * Function to check whether profiles type is horse profiles
 */
export function isHorseProfiles(profilesType) {
    return profilesType === PROFILES_TYPE_HORSE_PROFILES;
}



// WEBPACK FOOTER //
// ./src/js/Profiles/profiles.utils.js